import { Directive, ElementRef, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, Type } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app-config.loader';
import { AnagraficaBaseService } from 'src/app/core/anagrafica-base.service';
import { ClassificaI18nPipe } from '../pipes/classifica-i18n.pipe';

@Directive({
  selector: '[appAnagraficaView]'
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class AnagraficaViewDirective<TItem extends Record<string, any>, TService extends AnagraficaBaseService<TItem>> implements OnInit, OnDestroy {
  @Input('appAnagraficaView') serviceType!: Type<TService>;
  @Input() set qualifica(value: number) {
    this._qualifica = value;
    this.setText();
  }

  @Input() set anagraficaId(value: number | undefined) {
    this._anagraficaId = value;
    this.setText();
  }

  @Output() anagraficaItemsChanged = new EventEmitter<TItem[]>();

  private classificai18n: ClassificaI18nPipe;
  private htmlElem: HTMLElement;
  private service: TService | undefined;
  private _anagraficaId: number | undefined;
  private _qualifica: number | undefined;
  private getAllSubscription: Subscription | undefined;
  private allItems: TItem[] | undefined;

  constructor(private appConfig: AppConfig, private injector: Injector, el: ElementRef) {
    this.htmlElem = el.nativeElement as HTMLElement;
    this.classificai18n = new ClassificaI18nPipe(this.appConfig);
  }

  ngOnInit(): void {
    this.service = this.injector.get<TService>(this.serviceType);
    this.getAllSubscription = this.service.getAll().subscribe(a => {
      this.allItems = a;
      this.anagraficaItemsChanged.emit(a);
      this.setText();
    });
  }

  ngOnDestroy(): void {
    if (this.getAllSubscription) {
      this.getAllSubscription.unsubscribe();
    }
  }

  private setText() {
    if (!this.allItems || !this.service || typeof this._anagraficaId !== 'number') {
      this.htmlElem.textContent = '';
      return;
    }

    const item = this.allItems.find(i => this.service && this.service.getItemId(i) === this._anagraficaId);
    if (!item) {
      this.htmlElem.textContent = '';
      return;
    }

    if (!this._qualifica) {
      this.htmlElem.textContent = item[this.service.nameProperty] as string;
      return;
    }

    this.htmlElem.textContent = this.classificai18n.transform(item[this.service.nameProperty] as string, this._qualifica);
  }
}
